import { render, staticRenderFns } from "./MethodAccordSetting.vue?vue&type=template&id=1407cd53&scoped=true"
import script from "./MethodAccordSetting.vue?vue&type=script&lang=js"
export * from "./MethodAccordSetting.vue?vue&type=script&lang=js"
import style0 from "./MethodAccordSetting.vue?vue&type=style&index=0&id=1407cd53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407cd53",
  null
  
)

export default component.exports